var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChart = function SvgChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99928 4.16797C10.6409 4.16797 11.1659 4.69297 11.1659 5.33464V14.668C11.1659 15.3096 10.6409 15.8346 9.99928 15.8346C9.35761 15.8346 8.83261 15.3096 8.83261 14.668V5.33464C8.83261 4.69297 9.35761 4.16797 9.99928 4.16797ZM5.33293 7.66813H5.49959C6.14126 7.66813 6.66626 8.19313 6.66626 8.8348V14.6681C6.66626 15.3098 6.14126 15.8348 5.49959 15.8348H5.33293C4.69126 15.8348 4.16626 15.3098 4.16626 14.6681V8.8348C4.16626 8.19313 4.69126 7.66813 5.33293 7.66813ZM15.8331 12.0026C15.8331 11.3609 15.3081 10.8359 14.6664 10.8359C14.0248 10.8359 13.4998 11.3609 13.4998 12.0026V14.6693C13.4998 15.3109 14.0248 15.8359 14.6664 15.8359C15.3081 15.8359 15.8331 15.3109 15.8331 14.6693V12.0026Z",
    fill: "#777776"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chart.588444c8.svg";
export { ForwardRef as ReactComponent };